'use strict';

export function routerDecorator($rootScope, $state, Auth, $cookies) {
  'ngInject';
  // Redirect to login if route requires auth and the user is not logged in, or doesn't have required role

  $rootScope.$on('$stateChangeStart', function(event, next) {
    if(!next.authenticate) {
      return;
    }

    if(next.authenticate) {
      if($cookies.getAll().token){
       return;
      } else {
        event.preventDefault();
        $state.go('login');
      }

    } 
   
  });
}



// WEBPACK FOOTER //
// ./client/components/auth/router.decorator.js